const TEMPLATE_ROWS = {
  clustered: [
    ['cluster', 'size'],
    ['Manaus', '25'],
    ['Sao Paulo', '25'],
    ['Rio', '25'],
    ['Brasilia', '25']
  ],
  'stratified-blocked': null,
  'stratified-random-block': null,
  'cluster-stratum': [
    ['cluster', 'size'],
    ['Manaus', '40'],
    ['Sao Paulo', '60']
  ],
  'cluster-stratified': [
    ['stratum', 'cluster', 'size'],
    ['Norte', 'Manaus', '25'],
    ['Norte', 'Belem', '25'],
    ['Sudeste', 'Sao Paulo', '25'],
    ['Sudeste', 'Rio', '25']
  ]
};

function escapeCsv(value) {
  const stringValue = value === null || value === undefined ? '' : String(value);

  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
}

function templateToCsv(technique) {
  if (technique === 'stratified-blocked' || technique === 'stratified-random-block') {
    return [
      ['id', 'sexo', 'faixa_etaria', 'centro'],
      ['P001', 'F', '<60', 'Manaus'],
      ['P002', 'M', '<60', 'Manaus'],
      ['P003', 'F', '>=60', 'Sao Paulo'],
      ['P004', 'M', '>=60', 'Sao Paulo']
    ].map((row) => row.map(escapeCsv).join(',')).join('\n');
  }

  const rows = TEMPLATE_ROWS[technique];

  if (!rows) {
    throw new Error('CSV templates are available for cluster and stratified methods only.');
  }

  return rows.map((row) => row.map(escapeCsv).join(',')).join('\n');
}

function parseCsvLine(line) {
  const cells = [];
  let current = '';
  let quoted = false;

  for (let index = 0; index < line.length; index += 1) {
    const char = line[index];
    const next = line[index + 1];

    if (char === '"' && quoted && next === '"') {
      current += '"';
      index += 1;
    } else if (char === '"') {
      quoted = !quoted;
    } else if (char === ',' && !quoted) {
      cells.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  cells.push(current.trim());
  return cells;
}

function parseCsv(text) {
  const lines = String(text || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length < 2) {
    throw new Error('CSV must include a header row and at least one data row.');
  }

  const headers = parseCsvLine(lines[0]).map((header) => header.toLowerCase());
  return lines.slice(1).map((line) => {
    const cells = parseCsvLine(line);
    return headers.reduce((row, header, index) => {
      row[header] = cells[index] || '';
      return row;
    }, {});
  });
}

function requireColumns(rows, columns) {
  const missing = columns.filter((column) => !(column in rows[0]));

  if (missing.length > 0) {
    throw new Error(`CSV is missing required columns: ${missing.join(', ')}`);
  }
}

function parseColumnList(value) {
  return String(value || '')
    .split(',')
    .map((column) => column.trim().toLowerCase())
    .filter(Boolean);
}

function inferStratificationColumns(rows) {
  const ignored = new Set(['id', 'patient_id', 'participant_id', 'subject_id']);
  return Object.keys(rows[0] || {}).filter((column) => !ignored.has(column));
}

function rowsToCompositeStrata(rows, stratificationColumns = []) {
  const columns = stratificationColumns.length ? stratificationColumns : inferStratificationColumns(rows);

  if (columns.length === 0) {
    throw new Error('Participant-level CSV must include at least one stratification column.');
  }

  requireColumns(rows, columns);

  const counts = new Map();
  rows.forEach((row, rowIndex) => {
    const values = columns.map((column) => {
      const value = String(row[column] || '').trim();

      if (!value) {
        throw new Error(`CSV row ${rowIndex + 2} is missing value for ${column}.`);
      }

      return value;
    });
    const key = values.join(' / ');
    counts.set(key, (counts.get(key) || 0) + 1);
  });

  return Array.from(counts.entries())
    .map(([stratum, size]) => `${stratum}:${size}`)
    .join(',');
}

function rowsToTechniqueInput(technique, rows, options = {}) {
  if (technique === 'cluster-stratified') {
    requireColumns(rows, ['stratum', 'cluster', 'size']);
    return rows.map((row) => `${row.stratum}|${row.cluster}:${row.size}`).join(',');
  }

  if (technique === 'clustered' || technique === 'cluster-stratum') {
    requireColumns(rows, ['cluster', 'size']);
    return rows.map((row) => `${row.cluster}:${row.size}`).join(',');
  }

  if (technique === 'stratified-blocked' || technique === 'stratified-random-block') {
    if ('stratum' in rows[0] && 'size' in rows[0]) {
      requireColumns(rows, ['stratum', 'size']);
      return rows.map((row) => `${row.stratum}:${row.size}`).join(',');
    }

    return rowsToCompositeStrata(rows, parseColumnList(options.stratificationColumns));
  }

  throw new Error('CSV import is available for cluster and stratified methods only.');
}

function getCsvTargetField(technique) {
  if (technique === 'clustered') {
    return 'clusterSizes';
  }

  if (technique === 'stratified-blocked' || technique === 'stratified-random-block') {
    return 'strataSizes';
  }

  if (technique === 'cluster-stratum') {
    return 'clusterStrata';
  }

  if (technique === 'cluster-stratified') {
    return 'clusterStrataSizes';
  }

  return null;
}

module.exports = {
  getCsvTargetField,
  inferStratificationColumns,
  parseCsv,
  parseColumnList,
  rowsToTechniqueInput,
  templateToCsv
};
